import React, { useState, useRef } from "react";
import Barcode from "react-barcode";
import { toPng } from "html-to-image";
import "./barcode reader.css";

function BarcodeGenerator() {
  const [brandName, setBrandName] = useState("");
  const [barcodeValue, setBarcodeValue] = useState("");
  const barcodeRef = useRef(null);





  const handleDownload = async () => {
  if (!barcodeRef.current) return;

  try {
    const dataUrl = await toPng(barcodeRef.current, {
      backgroundColor: null,
      pixelRatio: 3
    });

    const link = document.createElement("a");
    link.download = `${brandName || "barcode"}.png`;
    link.href = dataUrl;
    link.click();
  } catch (err) {
    console.error(err);
  }
};






  return (
    <div className="barcode-app">


      {/* Input Section */}
      <div className="input-section">
        <h1 className="app-title">Professional Barcode Generator</h1>

        <div className="input-group">
          <label htmlFor="brand">Brand Name</label>
          <input
            id="brand"
            type="text"
            value={brandName}
            onChange={(e) => setBrandName(e.target.value)}
            placeholder="Brand/Organization Name"
          />
        </div>

        <div className="input-group">
          <label htmlFor="barcode">Barcode Value</label>
          <input
            id="barcode"
            type="text"
            value={barcodeValue}
            onChange={(e) => setBarcodeValue(e.target.value)}
            placeholder="Enter barcode value"
          />
        </div>
      </div>

      {/* Barcode Display */}
      <div className="barcode-display">
        <div className="barcode-container" ref={barcodeRef}>
          {barcodeValue ? (
            <>
  <Barcode
  value={barcodeValue}
  format="CODE128"
  width={2}
  height={80}
  displayValue={false}
  background="transparent"
  margin={0}
/>







              {brandName && (
                <p className="brand-name">{brandName}</p>
              )}
            </>
          ) : (
            <p>Enter a value to generate barcode</p>
          )}
        </div>

        <button
          className="download-btn"
          onClick={handleDownload}
          disabled={!barcodeValue}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 15V3M12 15L8 11M12 15L16 11M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Download Barcode
        </button>
      </div>
    </div>
  );
}

export default BarcodeGenerator;